$( document ).ready(function() {
  
  //nintendo-switch-screen-protector-dev page  
  $('.nsbtn').click(function() {
    
    var variantid = $(this).data("variantid");
        
    CartJS.addItem(variantid);

    const loadCartDrawerTimeout = setTimeout(loadCartDrawer, 2000);

    function loadCartDrawer() {
      ajaxCart.load();
      clearTimeout(loadCartDrawerTimeout);
    }

        
  });
  $('.first_p_voptions').on('change', function (e) {
     var optionSelected = $('.first_p_voptions').find("option:selected");
     var qtyStatus   = optionSelected.attr("data-status"); 
     if(qtyStatus > 0)
     {
       $('#first_vstatus').html("Add to Cart");
     }
     else
     {
       $('#first_vstatus').html("Sold Out");
       $('#first_vstatus').addClass("disable");
     }
  });
  $('#first_vstatus').on('click', function (e) {
     var optionSelected = $('.first_p_voptions').find("option:selected");
     var valueSelected  = optionSelected.val();
     var textSelected   = optionSelected.text();
     CartJS.addItem(valueSelected);
     const loadCartDrawerTimeout = setTimeout(loadCartDrawer, 2000);
     function loadCartDrawer() {
       ajaxCart.load();
       clearTimeout(loadCartDrawerTimeout);
     }       
  });
  $('.second_p_voptions').on('change', function (e) {
     var optionSelected = $('.second_p_voptions').find("option:selected");
     var qtyStatus   = optionSelected.attr("data-status"); 
     if(qtyStatus > 0)
     {
       $('#second_vstatus').html("Add to Cart");
     }
     else
     {
       $('#second_vstatus').html("Sold Out");
       $('#second_vstatus').addClass("disable");
     }
  });
  $('#second_vstatus').on('click', function (e) {
     var optionSelected = $('.second_p_voptions').find("option:selected");
     var valueSelected  = optionSelected.val();
     var textSelected   = optionSelected.text();
     CartJS.addItem(valueSelected);
     const loadCartDrawerTimeout = setTimeout(loadCartDrawer, 2000);
     function loadCartDrawer() {
       ajaxCart.load();
       clearTimeout(loadCartDrawerTimeout);
     }       
  });
  
});